import type { BusinessSubscription } from "lens-platform-sdk";

export type UsedSeat = BusinessSubscription["usedSeats"][number];

export type ActiveSeat = UsedSeat & { deactivatedAt: null; subscription?: BusinessSubscription };

/**
 * @returns true if the `usedSeat` hasn't been deactivated (`deactivatedAt === null`)
 */
export const isActiveSeat = (usedSeat: UsedSeat): usedSeat is ActiveSeat => usedSeat.deactivatedAt === null;

export type CanceledSeat = UsedSeat & {
  deactivatedAt: string;
  subscription?: BusinessSubscription;
};

/**
 * @returns true if seat is canceled (`deactivatedAt !== null`,  UI uses the term "canceled")
 */
export const isCanceledSeat = (usedSeat: UsedSeat): usedSeat is CanceledSeat => usedSeat.deactivatedAt !== null;
